<!-- Page 1: Add Fisher Form -->
@if (!showConfirmationPage) {
  <div class="container"
    style="display: flex; flex-direction: column; justify-content: space-between; height:100%">
    <h3 i18n class="display-6"
      align="center"
      style="padding-top: 10px; color: #005d87; font-weight: bold;">
    Add Fisher
  </h3>
    <div class="row">
      <h6 i18n class="small-header">Fisher Name</h6>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="data.name">
      </mat-form-field>
      <h6 i18n class="small-header">FIN</h6>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>FIN</mat-label>
        <input type="number" matInput [(ngModel)]="data.fin">
      </mat-form-field>
    </div>
    <!-- Back and Add buttons -->
    <div class="row bottom-buttons">
      <div class="outer">
        <!-- "Back" button -->
        <div class="inner" style="margin-right: 50%">
          <button i18n mat-stroked-button
            type="button"
            style="background-color: #005d87; color: white; font-weight: bold;"
            (click)="onCancel()">
          Back
        </button>
        </div>
        <!-- "Add" button -->
        <div class="inner">
          <button i18n mat-stroked-button
            type="submit"
            style="background-color: #ff6f61; color: white; font-weight: bold;"
            (click)="onAdd()">
          Add
        </button>
        </div>
      </div>
    </div>
  </div>
}
<!-- Page 2: Confirmation / Info Message -->
@if (showConfirmationPage) {
  <div class="container"
    style="display: flex; flex-direction: column; justify-content: space-between; height:100%">
    <h3 align="center"
      style="padding-top: 20px; color: #005d87; font-weight: bold;">
      When a new fisher is added, please alert Archipelago so we can
      update DFO's database with their FIN.
    </h3>
    <!-- OK button -->
    <div class="row bottom-buttons" style="display: flex; justify-content: center;">
      <button mat-stroked-button
        type="submit"
        style="background-color: #ff6f61; color: white; font-weight: bold; width: 150px"
        (click)="onSave()">
        OK
      </button>
    </div>
  </div>
  } <!-- end second page -->
